/**
 * 判断是否为特定人
 */
export const isTargetPersons = (target_persons: number) =>
	!!target_persons && target_persons === 1;

/**
 * 将对象{x:1, y:2} => [{key: 'x', value: 1}, {key: 'y', value: 2}]
 */
export const convertObjectToArray = (obj) =>
	Object.keys(obj || {}).map((key) => {
		return { key: key, val: obj[key] || "-", desc: "-" };
	});
